<template>
  <Header />
  <router-view />
</template>
<script setup>
import { onMounted } from "vue"
import Header from "./components/Header.vue"
import update from "./mixins/update"

onMounted(() => {
  if (update.data().updateExists) {
    update.methods.refreshApp()
  }
})
</script>
<style>
@import "./assets/css/styles.css";

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px;
  flex: 1;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
